module.exports = __webpack_public_path__ + "static/media/medal_section_bg.96b628f9.png";